module.exports = __webpack_public_path__ + "media/images/category/feature/profile/profile-kim-a109a2f996bf8ad8e467d229051b51b3.jpg";